// assets/quiz-state.js
const SS_KEY = 'ds_quiz_state';
const CURRENT_VERSION = 1;

function uuid() {
  return crypto.randomUUID ? crypto.randomUUID() :
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

export class QuizState {
  constructor() {
    const existing = sessionStorage.getItem(SS_KEY);
    if (existing) {
      this._state = JSON.parse(existing);
    } else {
      this._state = { sessionId: uuid(), answers: {}, startedAt: Date.now() };
      this._persist();
    }
  }
  get sessionId() { return this._state.sessionId; }
  getAnswers() { return { ...this._state.answers }; }
  setAnswer(id, value) {
    this._state.answers[id] = value;
    this._persist();
  }
  clearAnswer(id) {
    if (Object.prototype.hasOwnProperty.call(this._state.answers, id)) {
      delete this._state.answers[id];
      this._persist();
    }
  }
  setEmail(email) {
    this._state.email = email;
    this._persist();
  }
  get email() { return this._state.email; }
  reset() {
    sessionStorage.removeItem(SS_KEY);
    this._state = { sessionId: uuid(), answers: {}, startedAt: Date.now() };
    this._persist();
  }
  _persist() { sessionStorage.setItem(SS_KEY, JSON.stringify(this._state)); }
}

export function encodeReplay(payload) {
  const json = JSON.stringify(payload);
  // btoa handles ASCII only; use encodeURIComponent -> unescape trick
  return btoa(unescape(encodeURIComponent(json)));
}

// Returns { ok: true, answers, sid, v } on success,
// or { ok: false, reason: 'malformed' | 'unknown_version' }.
// Spec §3.7: callers handle these two failure modes differently
// (malformed → log once + start fresh; unknown_version → redirect + toast).
export function decodeReplay(encoded, { currentVersion = CURRENT_VERSION } = {}) {
  if (!encoded || typeof encoded !== 'string') return { ok: false, reason: 'malformed' };
  let payload;
  try {
    const json = decodeURIComponent(escape(atob(encoded)));
    payload = JSON.parse(json);
  } catch {
    return { ok: false, reason: 'malformed' };
  }
  if (!payload || typeof payload !== 'object' || typeof payload.v !== 'number') {
    return { ok: false, reason: 'malformed' };
  }
  if (payload.v !== currentVersion) {
    return { ok: false, reason: 'unknown_version' };
  }
  return {
    ok: true,
    v: payload.v,
    sid: payload.sid,
    answers: payload.answers || {},
  };
}

if (typeof window !== 'undefined') {
  window.QuizState = QuizState;
  window.encodeReplay = encodeReplay;
  window.decodeReplay = decodeReplay;
}
